import { render, staticRenderFns } from "./VideoTableRow.vue?vue&type=template&id=4ce0991d&scoped=true&"
import script from "./VideoTableRow.vue?vue&type=script&lang=js&"
export * from "./VideoTableRow.vue?vue&type=script&lang=js&"
import style0 from "./VideoTableRow.vue?vue&type=style&index=0&id=4ce0991d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce0991d",
  null
  
)

export default component.exports